import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const dest = window.location.pathname || "/trips";
    (async () => {
      try {
        if (!sessionId) { navigate("/login", { replace: true }); return; }
        const r = await api.post("/auth/session", { session_id: sessionId });
        setUser(r.data);
        navigate(dest, { replace: true, state: { user: r.data } });
      } catch (e) { navigate("/login", { replace: true }); }
    })();
  }, [setUser, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-rr-bg" data-testid="auth-callback-loading">
      <Loader2 className="w-8 h-8 text-rr-gold animate-spin" strokeWidth={1} />
      <p className="overline mt-6">Preparing your journey</p>
    </div>
  );
}
